import { Pagination, Select, type TypeSelectOption } from '@thefarmersfront/kitchen';

import styles from './TableBottomField.module.scss';

const TableBottomField = ({
  pageSizeOptions,
  currentPage,
  totalCount,
  pageSize,
  leftField,
  onChangePageLimit,
  onClickPage,
}: {
  pageSizeOptions: TypeSelectOption<number>[];
  currentPage: number;
  totalCount: number;
  pageSize: number;
  leftField?: React.ReactNode;
  onChangePageLimit: (value: TypeSelectOption<number>) => void;
  onClickPage: (page: number) => void;
}) => {
  const handleChangePageLimit = (_: unknown, option: TypeSelectOption<number>) => {
    onChangePageLimit(option);
  };

  const handleClickPage = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const newPage = Number(e.currentTarget.value) - 1;

    onClickPage(newPage);
  };

  return (
    <div className={styles['table-bottom-field-container']}>
      <div className={styles['left-field-container']}>
        <Select
          maxWidth="86px"
          options={pageSizeOptions}
          value={pageSizeOptions.find(({ value }) => value === pageSize)}
          size="tiny"
          dropdownPlacement="top-left"
          onChange={handleChangePageLimit}
        />
        {leftField}
      </div>
      {totalCount ? (
        <Pagination
          currentPage={currentPage + 1}
          totalCount={totalCount}
          pageSize={pageSize}
          onClick={handleClickPage}
        />
      ) : null}
    </div>
  );
};

export default TableBottomField;
